export default __webpack_public_path__ + "static/media/09d.0b0315a5.png";